export default __webpack_public_path__ + "static/o_nas-silne_zazemi-a1fc79d38f046033e471f8694d8ae9d6.jpg";